module.exports = __webpack_public_path__ + "img/background.646b3d69.jpg";